export enum CustomerStatus {
  PROSPECT = 'PROSPECT',

  CUSTOMER = 'CUSTOMER',

  INACTIVE = 'INACTIVE',
}
